// listaConteo.js — pasa una lista de cajetines a "Contar cajetines" desde
// otra pestaña de Administración (p.ej. Panel dinámico > Pisos que necesitan
// copias). La lista queda pendiente hasta que Contar cajetines la recoge
// (tanto si ya estaba montado como si se monta después al cambiar de pestaña).
const EVENTO = "conteo:lista";
let pendiente = null;

// items: [{cajetin, pid, codigo}] ya en el orden en que se quieren contar.
export function enviarListaConteo(titulo, items) {
  pendiente = { titulo, items };
  window.dispatchEvent(new Event(EVENTO));
}

export function tomarListaConteo() {
  const x = pendiente;
  pendiente = null;
  return x;
}

export function onListaConteo(fn) {
  window.addEventListener(EVENTO, fn);
  return () => window.removeEventListener(EVENTO, fn);
}
